const AppLanguage = {
    English: 'en',
    Bulgarian: 'bg'
}

export const AppLanguageId = {
    'en': 1,
    'bg': 2
}

export default AppLanguage;